<ul class="content-tabs" *ngIf="data">

  <ng-container *ngFor="let item of data.items">
    <ng-container *ngIf="item.afterNumber !== 0">
      <li
        [ngClass]="{'active': item.id === currentActiveTab}"
        (click)="onTabSelected(item.id)">
        {{item.label}} <span *ngIf="item.afterNumber > 0">{{item.afterNumber}}</span>
      </li>
    </ng-container>

  </ng-container>

</ul>
